import { FC } from 'react';

import SvgIcon from '~src/shared/SvgIcon';
import { Question } from '~src/interfaces/question.interface';
import { translateContent } from '~src/services/translationServices';
import UrlText from '~src/shared/UrlText';

import { SummaryItemWrapper, DraggableIcon, QuestionTitle } from './summarySelect.sc';

interface OwnProps {
  question: Question;
}

const SummaryQuestionItem: FC<OwnProps> = props => (
  <SummaryItemWrapper>
    <DraggableIcon>
      <SvgIcon width="18px" height="14px" name="iconDraggable" />
    </DraggableIcon>
    <QuestionTitle>
      <UrlText blocked text={translateContent(props.question.title)} />
    </QuestionTitle>
  </SummaryItemWrapper>
);

export default SummaryQuestionItem;
